// extracted by mini-css-extract-plugin
export default {"list":"toc-node_list__czd8a","link":"toc-node_link__Febd5","active":"toc-node_active__iUfsr"};